export default __webpack_public_path__ + "static/media/banner1.618c52c4.jpg";